import { render, staticRenderFns } from "./ItsOrderDepart.vue?vue&type=template&id=6cd7d33f&scoped=true&"
import script from "./ItsOrderDepart.vue?vue&type=script&lang=js&"
export * from "./ItsOrderDepart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd7d33f",
  null
  
)

export default component.exports